import React from 'react';
import Select from 'react-select';

import { range, CURRENT_YEAR } from '../../helpers/various-helpers';

class YearSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.value || null
    };
  }

  onChange(value) {
    this.setState(
      { value },
      () => this.props.onSelect(value)
    );
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;

    if (value !== undefined && value !== this.state.value) {
      this.setState({ value });
    }
  }

  buildUpOptions() {
    // TODO replace with an endpoint
    const yearRange = [2002,2003,2004,2005,2006,2007,2008,2009,2010,2011,2012,2013,2014,2015,2016,2017,2018, 2020, 2022, 2024]

    yearRange.reverse();

    const allYears = yearRange.map(year =>
      Object.assign({}, { label: year, value: year })
    );
    allYears.unshift({ label: 'All years', value: '' });
    return allYears;
  }

  render() {
    return (
      <Select
        onChange={value => this.onChange(value)}
        value={this.state.value}
        className="country-select-list"
        name="year-select-list"
        placeholder="Select a year"
        clearable={false}
        options={this.buildUpOptions()}
      />
    );
  }
}

export default YearSelect;



// WEBPACK FOOTER //
// ./src/components/Selects/Year.js